const StockOut = () => {
  return (
    <div className="absolute inset-0 flex items-center justify-center z-20 pointer-events-none">
      <div className="bg-red-600 text-white text-2xl font-bold px-3 py-2 rounded-lg shadow-lg">
        Stock Out
      </div>
    </div>
  );
};

export default StockOut;
